// TODO: Define what would be the standard date format for the app for short and long dates when using time and without time

const DATE_FORMAT = {
	// Only day, month, and year
	monthAbbrDatePadded: "MMM DD, YYYY", // Aug 07, 2025
	isoDate: "YYYY-MM-DD", // 2025-08-07
	usDateDash: "MM-DD-YYYY", // 08-07-2025
	usDateDashShortYear: "MM-DD-YY", // 08-07-25
	usDateSlash: "MM/DD/YYYY", // 08/07/2025
	usDateSlashShortYear: "MM/DD/YY", // 08/07/25
	monthNameDate: "MMMM D, YYYY", // August 7, 2025
	monthAbbrDate: "MMM D, YYYY", // Aug 7, 2025
	monthAbbrDateLower: "MMM d, yyyy", // Aug 7, 2025 (to be used with format from date-fns library)
	monthNameDatePadded: "MMMM DD, YYYY", // August 07, 2025
	monthNameOrdinal: "MMMM Do, YYYY", // August 7th, 2025

	// Full format with time
	usDateDashTime12h: "MM-DD-YYYY hh:mm A", // 08-07-2025 01:05 AM
	fullOrdinalTime12h: "MMMM Do, YYYY h:mm:ss A", // August 7th, 2025 1:05:01 AM
	fullAbbrTime12h: "MMM D, YYYY h:mm A", // Aug 7, 2025 1:05 AM
	fullLongTime12hLower: "MMMM D, YYYY h:mm a", // August 7, 2025 1:05 am
	fullAbbrTime12hPadded: "MMM D, YYYY hh:mm A", // Aug 7, 2025 01:05 AM
	isoTimestampWithZone: "YYYY-MM-DD hh:mm:ssA z", // 2025-08-07 01:05:01AM
	isoWithMillis: "YYYY-MM-DDTHH:mm:ss.SSS", // 2025-08-07T01:05:01.000
	isoCompact: "YYYY-MM-DD-HH-mm-ss", // 2025-08-07-01-05-01
	usDateTime12hPadded: "MM/DD/YYYY hh:mm A", // 08/07/2025 01:05 AM
	usDateTime24hSeconds: "MM/DD/YYYY HH:mm:ss", // 08/07/2025 01:05:01
	usDateTime12hUnpadded: "MM/DD/YYYY h:mm A", // 08/07/2025 1:05 AM (h is 12-hour format)
	abbrDatePaddedTime12h: "MMM DD, YYYY h:mm A", // Aug 07, 2025 1:05 AM
	longDatePaddedTime12h: "MMMM D, YYYY hh:mm A", // August 7, 2025 01:05 AM
	abbrDateOrdinalTime: "MMM Do YYYY, h:mm A", // Aug 7th 2025, 1:05 AM
	abbrDatePaddedOrdinalTime: "MMMM Do, YYYY hh:mm A", // August 7th, 2025 01:05 AM
	usDateTimeWithZeroedSeconds: "MM/DD/YYYY HH:mm:00", // 08/07/2025 01:05:00
	shortDateUnpaddedTime12h: "M/D/YYYY, h:mm A", // 08/07/2025 01:05:01
	abbrMonthDayTime: "MMM/DD hh:mm A", // Aug/07 01:05 AM

	// Custom
	yearOnly: "YYYY", // 2025
	monthLong: "MMMM", // August
	monthAbbr: "MMM", // Aug
	yearMonth: "YYYY-MM", // 2025-08
	monthDayAbbrPadded: "MMM DD", // Aug 07
	monthDayAbbr: "MMM D", // Aug 7
	monthDayOrdinal: "MMMM Do", // August 7th
	dayYear: "D YYYY", // 7 2025
	day: "D", // 7
	dayPadded: "DD", // 07
	time12h: "hh:mm A", // 01:05 AM
	time24h: "HH:mm", // 01:05
	monthShortDateOrdinal: "MMM Do", // Aug 7th
};

export { DATE_FORMAT };
